import { render, staticRenderFns } from "./SearchContainer.vue?vue&type=template&id=22bd30b8&"
import script from "./SearchContainer.vue?vue&type=script&lang=js&"
export * from "./SearchContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports